import { useSelector } from "react-redux";
import { defaultPathname } from "../utils/constants/constants";
import { orderBy } from "lodash-es";
import { useMustConfigure2FA } from "./authHooks";

export const usePathName = () => {
  const mustConfigure2FA = useMustConfigure2FA();
  const pages = useSelector((state) => state.layout.tabs);
  if (mustConfigure2FA) {
    return "/user-profile";
  }
  return defaultPathname.concat(orderBy(pages, "position")[0]?.slug || "home");
};
